module.exports = __webpack_public_path__ + "img/reunion_566.5e8f3e68.png";